import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { IoMdUnlock } from 'react-icons/io';

// components
import { PasswordInput } from 'components/PasswordInput';
// assets
import noVideoBackground from 'assets/images/noVideoBackground.png';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

const ProtectedVideoContainer = styled.div`
  background-image: url(${noVideoBackground});
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  height: 100vh;
  > div {
    height: 280px;
    display: flex;
    flex-direction: column;
    width: 384px;
    color: #fff;
    padding: 24px;
    border-radius: 4px;
    > span {
      font-size: 22px;
      font-weight: bold;
      display: flex;
      line-height: 1.45;
    }
    > p {
      margin: 8px 0 32px;
      font-size: 14px;
      max-width: 384px;
      line-height: 1.14;
    }
    > label {
      color: #cecece;
      font-size: 14px;
      text-align: left;
    }
  }
`;

type Props = {
  loading: boolean;
  onSubmit: (password: string) => void;
};

export const ProtectedVideo = ({ loading = false, onSubmit }: Props) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');

  const onUnlockClick = () => {
    setError('');

    if (!password?.trim()) {
      setError(t('Invalid Password'));
      return;
    }

    onSubmit(password);
  };

  return (
    <ProtectedVideoContainer>
      <div>
        <span>{t('videoProtectedTitle')}</span>
        <p>{t('videoProtectedDescription')}</p>

        <label>{t('enterPasswordLabel')}</label>
        <PasswordInput
          password={password}
          onChange={setPassword}
          error={error}
          onEnter={onUnlockClick}
        />
        <Button
          variant='white'
          text={t('unlockVideo')}
          icon={<IoMdUnlock />}
          disabled={loading}
          onClick={onUnlockClick}
        />
      </div>
    </ProtectedVideoContainer>
  );
};
